import React from 'react';
import Modal from '../../../Components/Modal/Modal';
import useTranslation from '../../../Hooks/useTranslation';
import { useTreatmentContext } from '../../../Services/TreatmentContext';
import Text from '../../../Components/Base/Text/Text';
import Button from '../../../Components/Button/Button';
import { Theme } from '../../../Enums/Theme.enum';
import LinkButton from '../../../Components/Button/LinkButton';
// @ts-ignore
import styles from './ModalCloseConfirmation.module.scss';

interface Props {
	isOpen: boolean;
	onConfirm: () => void;
	onReject: () => void;
}

const ModalCloseConfirmation: React.FC<Props> = ({
	isOpen,
	onConfirm,
	onReject,
}) => {
	const { t } = useTranslation();
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={isOpen} onClose={onReject} wrapChat={isCase}>
			<Modal.Header title={t('component.modalCloseConfirmation.title')} />
			<Modal.Content>
				<div>
					<Text tx='component.modalCloseConfirmation.text' />
					<div className={styles.buttonsWrapper}>
						<Button
							theme={Theme.GREEN}
							title='component.modalCloseConfirmation.rejectButton'
							onClick={() => onReject()}
						/>
						<LinkButton
							title='component.modalCloseConfirmation.confirmButton'
							theme={Theme.RED}
							onClick={() => onConfirm()}
						/>
					</div>
				</div>
			</Modal.Content>
		</Modal>
	);
};

export default ModalCloseConfirmation;
